import { render, staticRenderFns } from "./safe-sku-table.vue?vue&type=template&id=928f8cb6&"
import script from "./safe-sku-table.vue?vue&type=script&lang=js&"
export * from "./safe-sku-table.vue?vue&type=script&lang=js&"
import style0 from "./safe-sku-table.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports